import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

class Stock extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Deposito",
                    id: "Deposito_nombre",
                    accessor: d => d.Deposito_nombre,
                    show: true,
                },
                {
                    Header: "Artículo",
                    id: "Articulo_nombre",
                    accessor: d => d.Articulo_nombre,
                    show: true,
                },
                {
                    Header: "Cantidad",
                    id: "Cantidad",
                    accessor: d => d.Cantidad,
                    className:"text-center",
                    show: true,
                    width:100,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                apiUrl={api.gestion.stock.stock}
                columns={this.state.columns}
                title={"Stock"}
            />
        );
    }
}

export default Stock;



// WEBPACK FOOTER //
// ./src/views/Gestion/Stock/Stock/Stock.js